export const redirectToBankPage = (paymentMode: string, resp: any) => {
  if (
    paymentMode.toUpperCase() === 'CREDIT_CARD' ||
    paymentMode.toUpperCase() === 'DEBIT_CARD' ||
    paymentMode.toUpperCase() === 'NET_BANKING' ||
    paymentMode.toUpperCase() === 'UPI'
  ) {
    const respBody = resp.data && resp.data.body;

    if (respBody) {
      const bankForm = respBody.bankForm;

      if (bankForm && bankForm.redirectForm) {
        const redirectionFormUrl = bankForm.redirectForm.actionUrl;

        if (redirectionFormUrl) {
          try {
            let content = '';
            if (bankForm.redirectForm && bankForm.redirectForm.content) {
              Object.keys(bankForm.redirectForm.content).forEach(
                (key) =>
                  (content +=
                    '    <input type="hidden" name="' +
                    key +
                    '" value="' +
                    bankForm.redirectForm.content[key] +
                    '" />\n'),
              );
            }

            let header = ' method="post"\t';
            Object.keys(bankForm.redirectForm.headers).forEach(
              // TODO: handle dependencies history, userSelectedDemandId
              // eslint-disable-next-line no-useless-concat
              (key) => (header += key + '=' + '"' + bankForm.redirectForm.headers[key] + '"'),
            );

            if (bankForm.redirectForm && bankForm.redirectForm.headers) {
              if (bankForm.redirectForm.headers.enctype) {
                header += ' enctype="' + bankForm.redirectForm.headers.enctype + '"\t';
              } else if (bankForm.redirectForm.headers['Content-Type']) {
                header += ' enctype="' + bankForm.redirectForm.headers['Content-Type'] + '"\t';
              }

              const html =
                ' <!DOCTYPE html>\n<html>\n' +
                '<head>\n' +
                '<meta name="viewport" content="width=device-width, initial-scale=1">' +
                '<style>\n' +
                '.submitButton {opacity: 0}' +
                '\n' +
                '.container{\n' +
                '  height: calc(100vh);\n' +
                '  display: flex;\n' +
                '  justify-content: center;\n' +
                '  align-items: center;\n' +
                '}\n' +
                '\n' +
                '.loader {\n' +
                '  margin: 25px 0;\n' +
                '  width: 50px;\n' +
                '  height: 50px;\n' +
                '  border-radius: 50%;\n' +
                '  border: 4px solid transparent;\n' +
                '  background-size: 100% 100%, 50% 50%, 50% 50%, 50% 50%, 50% 50%;\n' +
                '  background-repeat: no-repeat;\n' +
                '  background-image: linear-gradient(white, white),\n' +
                '                    linear-gradient(90deg, #E49310 45%, #9BB631 45%),\n' +
                '                    linear-gradient(180deg, #319CCA 45%, #3F3FD4 45%),\n' +
                '                    linear-gradient(270deg, #80237C 45%,  #9C0034 45%),\n' +
                '                    linear-gradient(360deg, #BA1F0D 45%, #D03F24 45%);\n' +
                '  background-position: center center, left top, right top, left bottom, right bottom;\n' +
                '  background-origin: content-box, border-box, border-box, border-box, border-box;\n' +
                '  background-clip: content-box, border-box, border-box, border-box, border-box;\n' +
                '  -webkit-animation: spin 2s linear infinite;\n' +
                '  animation: spin 2s linear infinite;\n' +
                ' \n' +
                '}\n' +
                '\n' +
                '@-webkit-keyframes spin {\n' +
                '  0% { -webkit-transform: rotate(0deg); }\n' +
                '  100% { -webkit-transform: rotate(360deg); }\n' +
                '}\n' +
                '\n' +
                '@keyframes spin {\n' +
                '  0% { transform: rotate(0deg); }\n' +
                '  100% { transform: rotate(360deg); }\n' +
                '}' +
                '</style>\n' +
                '</head>\n' +
                '<body>' +
                '<form id = "bankform" action="' +
                redirectionFormUrl +
                '"\t ' +
                header +
                '>\n' +
                content +
                '<input class="submitButton" type="submit" value="submit" >\n' +
                '</form>' +
                '<div class="container">\n' +
                '  <div class="loader"></div>\n' +
                '</div>' +
                '</body>\n' +
                '</html>';
              const form = document.createElement('div');
              form.innerHTML = html;
              document.body.appendChild(form);
              setTimeout(() => {
                const el: any = document.getElementById('bankform');
                el && el.submit();
              }, 10);
            }
          } catch (e) {
            console.error(e);
          }
        }
      }
    }
  }
};
